import { useState, useCallback } from 'react';

/**
 * Custom hook for managing popup menu state and interactions
 * @param {Object} initialState - Initial state for the popup menu
 * @returns {Object} Popup menu state and handlers
 */
export const usePopupMenu = (initialState = { show: false, x: 0, y: 0, item: null }) => {
  const [popupMenu, setPopupMenu] = useState(initialState);

  const handleItemClick = useCallback((event, item) => {
    // Prevent the click from bubbling up and triggering the outside click handler
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }
    // Use mouse position if available, otherwise fallback to element center
    let x, y;
    if (event && typeof event.clientX === 'number' && typeof event.clientY === 'number') {
      x = event.clientX;
      y = event.clientY;
    } else if (event && event.currentTarget && event.currentTarget.getBoundingClientRect) {
      const rect = event.currentTarget.getBoundingClientRect();
      x = rect.left + rect.width / 2;
      y = rect.bottom + 5;
    } else {
      x = 0;
      y = 0;
    }
    setTimeout(() => {
      setPopupMenu({
        show: true,
        x,
        y,
        item: item
      });
    }, 0);
  }, []);

  const closePopupMenu = useCallback(() => {
    setPopupMenu({ show: false, x: 0, y: 0, item: null });
  }, []);

  return {
    popupMenu,
    handleItemClick,
    closePopupMenu,
    setPopupMenu
  };
};
